// extracted by mini-css-extract-plugin
export var blok_content = "index-module--blok_content--a84bc";
export var blok_title = "index-module--blok_title--adf37";
export var bottom_cta_blok = "index-module--bottom_cta_blok--cef33";
export var bottom_cta_card = "index-module--bottom_cta_card--ee3db";
export var btn_container = "index-module--btn_container--b71e8";
export var card_img = "index-module--card_img--2540c";
export var card_tips = "index-module--card_tips--8e6b7";
export var img_text_container = "index-module--img_text_container--62162";
export var text_container = "index-module--text_container--6ae75";
export var title_header = "index-module--title_header--96733";